import { VerifyEmailState } from './types';

export const EMAIL_VERIFICATION_RESEND_DELAY_SECONDS = 60;

export const getShouldInvalidateUserProfile = (state: VerifyEmailState): boolean => {
  return state === 'already_confirmed' || state === 'confirmed';
};

export const getVerifyEmailStateFromErrorCode = (errorCode: unknown): VerifyEmailState => {
  if (errorCode === 'already_confirmed' || errorCode === 'expired') return errorCode;

  return 'not_found';
};